import type { SVGProps } from "react";

/**
 * birefnet
 * @category Social Media & Brands
 */
export default function IconBiRefNet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 32 32' fill='none' aria-hidden {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M17.6482 10.1305 15.8785 7.02583 7.02979 22.5499H10.5278L17.6482 10.1305ZM19.8798 14.0457 18.11 17.1983 19.394 19.4511H16.8453L15.1056 22.5499H24.7272L19.8798 14.0457Z'
        clipRule='evenodd'
      />
    </svg>
  );
}
